export const ADD_MESSAGE = "toastMessages.ADD_MESSAGE";
export const REMOVE_MESSAGE = "toastMessages.REMOVE_MESSAGE";
export const CLEAR_MESSAGES = "toastMessages.CLEAR_MESSAGES";
